import { COURSE_CLASS, P1 } from "./config.js";

const BASE = "https://parseapi.back4app.com";

export const REST = (appId, apiKey) => {
  const headers = {
    "X-Parse-Application-Id": appId,
    "X-Parse-REST-API-Key":   apiKey,
    "Content-Type": "application/json",
  };
  return {
    get:    async (path, qs = "") => { const r = await fetch(`${BASE}/classes/${path}${qs}`, { headers }); if (!r.ok) throw new Error(`GET ${r.status}`); return r.json(); },
    post:   async (path, body)    => { const r = await fetch(`${BASE}/classes/${path}`, { method:"POST",   headers, body: JSON.stringify(body) }); if (!r.ok) throw new Error(`POST ${r.status}`); return r.json(); },
    put:    async (path, body)    => { const r = await fetch(`${BASE}/classes/${path}`, { method:"PUT",    headers, body: JSON.stringify(body) }); if (!r.ok) throw new Error(`PUT ${r.status}`); return r.json(); },
    delete: async (path)          => { const r = await fetch(`${BASE}/classes/${path}`, { method:"DELETE", headers }); if (!r.ok) throw new Error(`DEL ${r.status}`); return r.json(); },
  };
};

export const API = {
  /* CourseList 전용 (항상 P1) */
  course: {
    list:   async (params = {}) => REST(P1.appId, P1.apiKey || P1.restKey).get(COURSE_CLASS, `?order=-createdAt&limit=${params.limit || 200}`),
    create: async (data)        => REST(P1.appId, P1.apiKey || P1.restKey).post(COURSE_CLASS, data),
    update: async (id, data)    => REST(P1.appId, P1.apiKey || P1.restKey).put(`${COURSE_CLASS}/${id}`, data),
    remove: async (id)          => REST(P1.appId, P1.apiKey || P1.restKey).delete(`${COURSE_CLASS}/${id}`),
  },

  /* 참여자 */
  ptcp(prog) {
    const headers = {
      "X-Parse-Application-Id": prog.appId,
      "X-Parse-REST-API-Key":   prog.apiKey || prog.restKey || prog.jsKey,
      "Content-Type": "application/json",
    };
    return {
      list: async (table, params = {}) => {
        const qs  = new URLSearchParams({ order: "-score", limit: params.limit || 200 }).toString();
        const res = await fetch(`${BASE}/classes/${table}?${qs}`, { headers });
        if (!res.ok) throw new Error(`참여자 조회 실패 ${res.status}`);
        return res.json();
      },
      create: async (table, data) => {
        const res = await fetch(`${BASE}/classes/${table}`, { method:"POST", headers, body: JSON.stringify(data) });
        if (!res.ok) throw new Error(`참여자 추가 실패 ${res.status}`);
        return res.json();
      },
      remove: async (table, id) => {
        const res = await fetch(`${BASE}/classes/${table}/${id}`, { method:"DELETE", headers });
        if (!res.ok) throw new Error(`삭제 실패 ${res.status}`);
        return {};
      },
    };
  },

  /* 코드 테이블 */
  codes(prog) {
    const headers = {
      "X-Parse-Application-Id": prog.appId,
      "X-Parse-REST-API-Key":   prog.apiKey || prog.restKey || prog.jsKey,
      "Content-Type": "application/json",
    };
    const restGet  = async (path, params = {}) => {
      const qs  = new URLSearchParams(params).toString();
      const res = await fetch(`${BASE}/classes/${path}${qs ? "?" + qs : ""}`, { headers });
      if (!res.ok) throw new Error(`GET ${path} ${res.status}`);
      return res.json();
    };
    const restPost = async (path, body) => {
      const res = await fetch(`${BASE}/classes/${path}`, { method:"POST", headers, body: JSON.stringify(body) });
      if (!res.ok) throw new Error(`POST ${path} ${res.status}`);
      return res.json();
    };
    return {
      listByCourse: async (useDate, round) => {
        const roundAlpha = String.fromCharCode(96 + round);
        const where = JSON.stringify({ useDate, round: roundAlpha });
        const data  = await restGet(prog.codeTable, { where, order: "entryCode", limit: 1000 });
        return (data.results || []).map(o => ({ objectId: o.objectId, ...o }));
      },
      createBatch: async (codes) => {
        if (!codes.length) return { created: 0, skipped: 0 };
        const where    = JSON.stringify({ entryCode: { $in: codes.map(c => c.entryCode) }, useDate: codes[0]?.useDate });
        const existing = await restGet(prog.codeTable, { where, limit: 1000 });
        const existSet = new Set((existing.results || []).map(o => o.entryCode));
        const newCodes = codes.filter(c => !existSet.has(c.entryCode));
        if (!newCodes.length) return { created: 0, skipped: codes.length };
        for (const c of newCodes) await restPost(prog.codeTable, c);
        return { created: newCodes.length, skipped: existSet.size };
      },
    };
  },
};

/* Parse SDK — 로그인용 */
export function loadLoginParse() {
  return new Promise((resolve) => {
    const init = () => {
      window.Parse.initialize(P1.appId, P1.jsKey);
      window.Parse.serverURL = "https://parseapi.back4app.com/";
      resolve(window.Parse);
    };
    if (window.Parse) { init(); return; }
    const s = document.createElement("script");
    s.src = "https://npmcdn.com/parse/dist/parse.min.js";
    s.onload = () => init();
    document.head.appendChild(s);
  });
}
